async function refreshCart() {
  const CART_JSON_URL = "/cart.json";
  const SECTION_ID    = "template--19416272601176__main-cart";

  try {
    const [cartRes, sectionRes] = await Promise.all([
      fetch(CART_JSON_URL, { headers: { Accept: "application/json" } }),
      fetch(`${window.location.pathname}?sections=${SECTION_ID},cart-icon-bubble`),
    ]);

    const [cartData, sections] = await Promise.all([
      cartRes.json(),
      sectionRes.json(),
    ]);

    // ======= Main cart body =======
    const mainCartHTML = sections[SECTION_ID];
    if (mainCartHTML) {
      const doc        = new DOMParser().parseFromString(mainCartHTML, "text/html");
      const freshInner = doc.querySelector("#Main-Cart-Details");
      const liveInner  = document.querySelector("#Main-Cart-Details");

      if (freshInner && liveInner) {
        liveInner.innerHTML = freshInner.innerHTML;

        // ======= Render Line item images =======
        liveInner.querySelectorAll("img[data-srcset]").forEach((img) => {
          const dataSrcset = img.getAttribute("data-srcset");
          img.setAttribute("srcset", dataSrcset);
          const firstSrc = dataSrcset.trim().split(",")[0].trim().split(" ")[0];
          if (firstSrc) img.src = firstSrc;
          img.removeAttribute("loading");
          img.classList.remove("image-lazy-loading", "loading-animation--breathing");
          img.classList.add("image-lazy-loaded");
        });

        // ======= Render Taggstar =======
        if (typeof window.taggstar?.basketRequest === "function") {
          const lineItems = cartData.items
            .map(item => ({
              id:        String(item.product_id),
              unitPrice: parseFloat((item.original_price / 100).toFixed(2)),
              quantity:  parseFloat(item.quantity),
            }))
            .filter(item => item.unitPrice > 0 && item.quantity > 0);

          setTimeout(() => {
            document.querySelectorAll(".tagg-balloons-wrapper.tagg-basket-page").forEach(el => {
              el.style.setProperty("display", "block", "important");
            });

            window.taggstar.basketRequest({ lineItems })
              .then(() => {
                document.querySelectorAll(".tagg-balloons-wrapper.tagg-basket-page").forEach(el => {
                  el.style.setProperty("display", "block", "important");
                });
              })
              .catch(err => console.warn("[refreshCart] Taggstar failed:", err));
          }, 1000);
        }
      }
    }

    // ======= Cart icon bubble =======
    const bubbleHTML = sections["cart-icon-bubble"];
    if (bubbleHTML) {
      const doc     = new DOMParser().parseFromString(bubbleHTML, "text/html");
      const freshEl = doc.querySelector(".shopify-section");
      const liveEl  = document.querySelector("#shopify-section-cart-icon-bubble .shopify-section");
      if (freshEl && liveEl) liveEl.innerHTML = freshEl.innerHTML;
    }

    // ======= Cart count dot =======
    const cartCountDot = document.querySelector(".cart-count-dot");
    if (cartCountDot) {
      if (cartData.item_count === 0) {
        cartCountDot.classList.add("is-hide");
      } else {
        cartCountDot.classList.remove("is-hide");
      }
    }

    // ======= Render DocApp =======
    if (typeof window.__docappCartReload === "function") {
      window.__docappCartReload();
    }

    // ======= Publish =======
    if (typeof webvista !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
      webvista.publish(PUB_SUB_EVENTS.cartUpdate, {
        source:           "cart-items",
        productVariantId: null,
        cartData: {
          ...cartData,
          items_added:   [],
          items_removed: [],
          sections,
        },
      });
    }

    // ======= Re-bind JS =======
    requestAnimationFrame(() => {
      if (typeof initGiftOptions === "function") initGiftOptions();
      const cartItemsEl = document.querySelector("cart-items");
      if (cartItemsEl?.applyCartPriceTiers) cartItemsEl.applyCartPriceTiers();
    });

    return { cartData, sections };

  } catch (err) {
    console.error("[refreshCart] Failed:", err);
    return null;
  }
}